import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { SolarFormsRepositoryService } from 'src/app/services/solarForms/solar-forms-repository.service';
import { CreateRTAFormComponent } from '../../create-rta-form/create-rta-form.component';
import {Location} from '@angular/common';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { mailDTO } from 'src/app/shared/models/user.model';

export class dialogInfo{
  name: string;
  message: string;
  data?: any;
  isRTAEdit?: boolean;
  isMassComm?: boolean;
}
@Component({
  selector: 'app-forms-confirmation-message',
  templateUrl: './forms-confirmation-message.component.html',
  styleUrls: ['./forms-confirmation-message.component.scss']
})
export class FormsConfirmationMessageComponent implements OnInit {
  dialogHeader: string;
  message: string;
  isLoadingData: boolean;
  isEdit: boolean;
  private unsubscribe: Subject<void> = new Subject<void>();
  @ViewChild(CreateRTAFormComponent) private createRTAFormComponent: CreateRTAFormComponent;
  roleInfo: any;
  isMassComm: boolean;
  fileList: any;
  
  constructor(private navigationPreviousPage: Location,
              private solarFormService: SolarFormsRepositoryService,
              private snackBarService: SnackBarService,
              private userRepository: UserRepositoryService,
              private dialogRef: MatDialogRef<FormsConfirmationMessageComponent>,
              @Inject(MAT_DIALOG_DATA) private config: dialogInfo,
    ) { }

  ngOnInit(): void {
    this.dialogHeader = this.config.name;
    this.message = this.config.message;
    this.isEdit = this.config.isRTAEdit;
    this.roleInfo = this.config.name == 'Send Mass Communication Email' ? this.config.data.roleName : '';
    this.isMassComm =  this.config.name == 'Send Mass Communication Email' && this.config.isMassComm ? this.config.isMassComm : false;
  }

  onYesClick() {
    this.isLoadingData = true; 
    if(this.isEdit) {
      this.solarFormService.updateRTAFormDetails(this.config.data)
      .pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
        if(data) {
          this.dialogRef.close();
          this.snackBarService.showSuccess(`RTA form has been submitted successfully.`); 
          this.isLoadingData=false;
          this.navigationPreviousPage.back();
        }else{
          this.dialogRef.close();
          this.isLoadingData=false;
          this.snackBarService.showError('An error has occurred. Please try again later'); 
        } 
      }, (error) => {
        if (error.status == 400) {
          this.snackBarService.showError("Invalid input!");
          this.isLoadingData = false;
        }
        else {
          this.isLoadingData = false;
        }
      });
    } else { 
      if (this.isMassComm) {
        let data = this.config.data;
        let formData: FormData = new FormData();
        let roleId = data.roleName.map(val => val.roleId).join(',');
        formData.append('subject', data.subject);
        formData.append('mailBody', data.mailBody);
        formData.append('roleIds', roleId);
        if (data.attachments) {
          for (let i = 0; i < data.attachments.length; i++) {
            formData.append('attachments', data.attachments[i]);
          }
        }

        this.userRepository.postMassCommunication(formData)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(data => {
            this.snackBarService.showSuccess('Email has been send successfully.');
            this.isLoadingData = false;
            this.dialogRef.close(true);
        }, err => {
          if(err.status == 403) {
            this.snackBarService.showError('Failed to send Mass Communciation Email.');
            this.dialogRef.close(true);
          } else {
            this.snackBarService.showError('Failed to send Mass Communciation Email.');
            this.dialogRef.close(true);
            console.log(err);
          }
        });
      } else {
        this.solarFormService.saveRTAFormInfo(this.config.data)
        .pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
          if (data) {
            this.dialogRef.close();
            this.snackBarService.showSuccess(`RTA form has been submitted successfully.`);
          } else {
            this.snackBarService.showError('An error has occurred. Please try again later');
          }
  
          this.isLoadingData = false;
          this.navigationPreviousPage.back();
        }, (error) => {
          if (error.status == 400) {
            this.snackBarService.showError("Invalid input!");
            this.isLoadingData = false;
          }
          else {
            this.isLoadingData = false;
            this.navigationPreviousPage.back();
          }
        });
      }
    }
  }

  onNoClick() {
    if(this.config.name == 'Send Mass Communication Email') {
      this.isLoadingData = false; 
      this.dialogRef.close(false);
    } else {
      this.isLoadingData = false; 
      this.dialogRef.close();
    }
    
  }

}
